import PropTypes from 'prop-types';
import React from 'react';
import Button from '$partials/ui/button';
import Logo from '$partials/icons/logo';
import Image from '$partials/media/image';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleAwardsEntrant = ({
    eyebrowLogo,
    eyebrowText,
    entrantName,
    profilePhoto,
    copy,
    stravaProfileLink
}) => {

    // render
    return (
        <div className='layout-container my-40'>
            <div
                className='bg-peach rounded p-30 md:py-40 md:px-50 flex max-md:flex-col md:-mx-50'>
                <div className='md:w-1/3 flex md:px-20 sm:max-md:mb-30'>
                    <div className='w-1/2 flex flex-col gap-20 md:gap-25'>
                        <div className='flex items-center self-start'>
                            {/* eyebrow logo/text / entrant name */}
                            {eyebrowLogo && (
                                <div className='mr-5'>
                                    <img
                                        alt={eyebrowLogo.alt}
                                        className='pointer-events-none'
                                        height='23'
                                        loading='lazy'
                                        role='presentation'
                                        src={eyebrowLogo.src}
                                        width='23' />
                                </div>
                            )}

                            {eyebrowText && (
                                <p className='text-orange type-style-awards-tiny'>{eyebrowText}</p>
                            )}
                        </div>
                        {entrantName && (
                            <h3 className='type-style-4'>{entrantName}</h3>
                        )}
                    </div>
                    <div className='w-1/2 md:pl-20 hidden md:block'>
                        {/* Desktop profile photo */}
                        {profilePhoto && (
                            <div className='aspect-square w-[124px]'>
                                <Image
                                    className={'h-full w-full object-cover'}
                                    containerClassName={'h-full w-full rounded-full'}
                                    containerStyle={{
                                        height: '100%',
                                        paddingBottom: 0,
                                    }}
                                    {...profilePhoto}/>
                            </div>
                        )}
                    </div>
                </div>
                <div className='md:w-1/2 md:px-20 flex flex-col gap-30 md:block'>
                    {/* copy */}
                    <p className='type-style-8'>
                        {copy}
                    </p>

                    {/* Mobile/tablet profile photo */}
                    <div className='w-1/2 md:pl-20 block md:hidden'>
                        {profilePhoto && (
                            <div className='aspect-square w-[124px]'>
                                <Image
                                    className={'h-full w-full object-cover'}
                                    containerClassName={'h-full w-full rounded-full'}
                                    containerStyle={{
                                        height: '100%',
                                        paddingBottom: 0,
                                    }}
                                    {...profilePhoto}/>
                            </div>
                        )}
                    </div>

                    {/* Link to Strava profile */}
                    {stravaProfileLink && (
                        <Button
                            as='a'
                            className='w-fit flex self-start items-center bg-orange text-white type-style-awards-tiny rounded px-20 py-15 md:mt-40'
                            href={stravaProfileLink}
                            renderIcon={<Logo />}
                            target='_blank'>
                            View profile on
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    eyebrowLogo: PropTypes.object,
    eyebrowText: PropTypes.string,
    entrantName: PropTypes.string,
    profilePhoto: PropTypes.object,
    copy: PropTypes.string,
    stravaProfileLink: PropTypes.string
};

ModuleAwardsEntrant.propTypes = propTypes;

export default ModuleAwardsEntrant;
